var _defs, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _path3, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpCatalogClampIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.g{fill:none;}.b,.d,.e,.f,.g{stroke:#3c3c46;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.b,.f{fill-rule:evenodd;}.c{fill:#3c3c46;opacity:0.2;}.d{fill:#fff;}.e{fill:#89d9fb;}.f{fill:#3ca4ef;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CP-catalog-clamp-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 140,
    height: 140
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.5,31h-2a2,2,0,0,0-2,2V47.64a2,2,0,0,0,2,2h2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.5,84.37h-2a2,2,0,0,0-2,2V101a2,2,0,0,0,2,2h2Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 31.5,
    y: 23,
    width: 86,
    height: 100
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 103.5,
    y: 17.1,
    width: 4,
    height: 99.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 99.5,
    y: 17.1,
    width: 4,
    height: 99.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 95.5,
    y: 17.1,
    width: 4,
    height: 99.8
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    x: 25.5,
    y: 17,
    width: 70,
    height: 100
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M71.35,47.72l-2.7,2.7a7.5,7.5,0,1,0,0,10.6l8.45,8.45A19.45,19.45,0,1,1,77.1,42Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 48.76,
    y1: 86.69,
    x2: 73.76,
    y2: 86.69
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "g",
    x1: 48.76,
    y1: 91.69,
    x2: 73.76,
    y2: 91.69
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpCatalogClampIcon);
export default __webpack_public_path__ + "static/media/CP-catalog-clamp-icon.d388bd211e8df4b4404db35887cdbbfb.svg";
export { ForwardRef as ReactComponent };